import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-name-avatar',
  template: `
    <div
      [style]="{
        width: width,
        height: height,
        backgroundColor: bgHaxColor,
        color: haxColor,
        fontSize: fontSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%'
      }"
    >
      {{ transform(name) }}
    </div>
  `,
})
export class NameAvatarComponent {
  @Input() name: string = '';
  @Input() haxColor: string = '#fff';
  @Input() bgHaxColor: string = '#3498db';
  @Input() width: string = '32px';
  @Input() height: string = '32px';
  @Input() fontSize: string = '1.125rem';


  transform(value: string): string {
    const names = value.split(' ');
    let initials = '';

    if (names.length >= 1) {
      initials += names[0].charAt(0).toUpperCase();
    }

    if (names.length > 1) {
      initials += names[names.length - 1].charAt(0).toUpperCase();
    }

    return initials;
  }
}
